package org.hs_soft.runmynesto.domain.usecase.product.tab_allergens

import org.hs_soft.runmynesto.domain.model.home.product.tabs.tab_allergen.create_product_ingredients.CreateProductIngredientModel
import org.hs_soft.runmynesto.domain.repository.network_datasource.product.tab_allergens.CreateProductIngredientRepository


class CreateProductIngredientUseCase(
    private val repository: CreateProductIngredientRepository
) {
    suspend operator fun invoke(
        productId:String,
        name: String,
        keyword: String,
        unit: String,
        number: String
    ): CreateProductIngredientModel {
        return repository.createProductIngredient(
            productId=productId,
            name=name,
            keyword=keyword,
            unit=unit,
            number=number,
        )
    }
}